import CrudAPI from '@/api/resources/crud'

export default {
  data () {
    return {
      loadingInProgress: true,
      loadingItemsText: 'Loading items...',
      items: []
    }
  },
  watch: {
    items (newItems) {
      this.loadingInProgress = false
      if (newItems.length === 0) {
        this.loadingItemsText = 'No items'
      }
    }
  },
  methods: {
    loadListing () {
      let result = CrudAPI.dfsResourceIndex(this.resources)

      this.items = []

      result.then(this.loadListingSuccess, this.loadListingError)
    },
    loadListingSuccess (result) {
      this.items = result
    },
    loadListingError (error) {
      this.items = []

      let handle = error // eslint-disable-line

      this.setNoItemsLoaded()
    },
    deleteElement (itemId) {
      let result = CrudAPI.dfsResourceDestroy(this.resources, itemId)

      result.then(this.deleteElementSuccess, this.deleteElementError)
    },
    deleteElementSuccess (result) {
      this.$bus.$emit('resource-deleted')
    },
    deleteElementError (error) {
      let handle = error // eslint-disable-line
    },
    editElement (itemId) {
      this.$store.dispatch('setEditItemId', itemId)
    },
    setNoItemsLoaded () {
      this.loadingInProgress = false
      this.loadingItemsText = 'No items'
    }
  },
  mounted () {
    this.$bus.$emit('component-loaded')
  },
  created () {
    this.$bus.$on([
      'resource-added',
      'resource-deleted',
      'resource-updated',
      'component-loaded'
    ], () => {
      this.$store.dispatch('setEditItemId', 0)

      this.loadListing()
    })

    this.$bus.$on('dialog-closed', () => {
      this.$store.dispatch('setEditItemId', 0)
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Resources.js